import type { FC } from "react"
import React from "react"

import styled from "styled-components"

import { ModalUnderlay } from "~/containers/proposal-styles"

import { ReactComponent as Exit } from "@svg/x.svg"

import { DesignRevisionDrawer } from "./DesignRevision"
import { EscalationDrawer } from "./Escalation"
import { useDesignerCapabilities } from "../designer-capabilities"
import { NoteDrawer } from "./Notes/NotesDrawer"

const Wrapper = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? `flex` : `none`)};
  flex-direction: column;
  gap: 20px;
  transition: 200ms ease-out;
  width: fit-content;
  height: 100vh;
  background: var(--white);
  padding: 20px 34px;
  pointer-events: all;
  z-index: 9999;
  position: fixed;
  right: 0;
  overflow-y: auto;

  h1 {
    font-size: 24px;
    line-height: 36px;
    color: var(--blue);
    font-weight: 500;
  }

  h3 {
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
    color: var(--blue-dark-font);
    text-transform: capitalize;
  }
`

const SeparationLine = styled.span`
  width: 100%;
  height: 1px;
  background: #dddddd;
`

const Close = styled(Exit)`
  position: absolute;
  top: 28px;
  right: 24px;
  cursor: pointer;
`

const DrawerUnderlay = styled(ModalUnderlay)`
  p {
    font-weight: 500;
    color: var(--blue);
  }
`

const Drawer_Internal: FC = () => {
  const { designRequest } = useDesignerCapabilities()

  if (!designRequest) {
    return null
  }

  return (
    <>
      <NoteDrawer />
      <DesignRevisionDrawer />
      <EscalationDrawer />
    </>
  )
}
export const Drawer = React.memo(Drawer_Internal)

export const DrawerContainer: FC<{
  children: React.ReactNode
  close: (close: boolean) => void
  isOpen: boolean
  title: string
}> = ({ children, isOpen, close, title }) => {
  return (
    <>
      <Wrapper isOpen={isOpen}>
        <h1>{title}</h1>
        <Close onClick={() => close(false)} />
        <SeparationLine />
        {children}
      </Wrapper>
      <DrawerUnderlay onClick={() => close(false)} isInUse={isOpen} />
    </>
  )
}
